"use client";

import Image from "next/image";
import partnersSvg from "../../public/bg_graphics/partners.svg";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div>
      {/* Background graphics */}
      <div
        className={`
          grid absolute top-0 left-0
          w-full h-full -z-[1] m-0
          overflow-hidden
        `}
      >
        <Image
          src={partnersSvg}
          alt="partners background arrows"
          fill
          sizes="100vw"
          className="object-cover object-top"
        />
      </div>
      {/* Content */}
      <div
        className={`
          grid-container relative
          py-36
        `}
      >
        <div className="col-start-1 col-span-4 lg:col-start-2 lg:col-span-14 2xl:col-start-4 2xl:col-span-26">
          <div className="flex flex-col text-center xl:text-left xl:max-w-[500px]">
            <h1 className="text-2xl xl:text-4xl">Out of bounds</h1>
            <p className="text-base xl:text-xl mt-5 xl:mt-8">
              Something went wrong...
            </p>
            <button
              className="text-[15px] 2xl:text-[17px] cursor-pointer text-center rounded-[6px] w-fit min-h-[40px] py-0 px-10 2xl:h-[45px] flex items-center justify-center disabled:opacity-30 disabled:cursor-default text-tm-c-base-light bg-tm-c-brand mt-5"
              onClick={() => reset()}
            >
              Try again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
